import request from '@/util/request';
import qs from 'qs';
//获取小区列表
export const getAreaZoneList = (params, options) =>
request.get('/api/base/property/optionNode', Object.assign({}, options, { params }));
//获取科目列表
export const getSubjectList = (params, options) =>
request.get('/api/v4ward/fee/subject/getSubjectList', Object.assign({}, options, { params }));
//获取标准列表
export const getStandardList = (params, options) =>
request.get('/api/v4ward/fee/standard/getStandardList', Object.assign({}, options, { params }));

//获取标准绑定列表分页数据
export const getStandardPageList = (params, options) =>
request.get('/api/v4ward/fee/standard/bind/page', Object.assign({}, options, { params }));

//房产树一级节点
export const loadRoomTree1 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getVisibleTree',
    Object.assign({}, options, { params })
  );

  //房产树子节点
  export const loadRoomTree2 = (params, options) =>
    request.get(
      '/api/propertyCharges/household/getChildrenNode',
      Object.assign({}, options, { params })
    );

export const removeStandard = (params, options) =>
request.post('/api/v4ward/fee/standard/bind/remove', qs.stringify(params), options);


  //房产树子节点
  export const getStandardDetail = (params, options) =>
    request.get(
      '/api/v4ward/fee/standard/detail',
      Object.assign({}, options, { params })
    );
    //获取已绑定对象
    export const getBindKeys = (params, options) =>
      request.get(
        '/api/v4ward/fee/standard/bind/bindKeys',
        Object.assign({}, options, { params })
      );

      
export const batchBind = (params, options) =>{
console.log(params);
  return request.post('/api/v4ward/fee/standard/bind/batchBind', params, options);
}
      
    //获取已绑定对象
    // export const checkTreeBind = (params, options) =>
    // request.get(
    //   '/api/v4ward/fee/standard/bind/checkBind',
    //   Object.assign({}, options, { params })
    // );
    export const checkTreeBind = (formData) => {
      return request({
        url: '/api/v4ward/fee/standard/bind/checkBind',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data: JSON.stringify(formData),
      });
    };
    // export const checkTreeBind = (params, options) =>
    // request.post('/api/v4ward/fee/standard/bind/checkBind', qs.stringify(params), options);

    //获取已绑定对象
    export const getLazyBasePropertyTree = (params, options) =>
      request.get(
        '/api/base/property/lazyBasePropertyTree',
        Object.assign({}, options, { params })
      );

      